module.exports = __webpack_public_path__ + "media/images/flags/1x1/mda-44917e3ad22f838d5f5824a5ebcbc38d.svg";